<template>
  <div :class="{ container: !isfirst, firstContainer: isfirst }">
    <h2 class="qtitle dotransition editabletext">
      {{ editingText ? "" : text }}
      <textarea v-if="editingText" :value="text" :id="'textinput' + id" />
      <EditButton :isEditing="editingText" @click="editText()" />
    </h2>
    <h5 class="requiredtext dotransition editabletext">
      {{ deselectable ? "Optional" : "Required" }}
      <EditButton :isEditing="false" @click="editRequired()" />
    </h5>
    <h5 class="dotransition editabletext" style="margin-top: 0.2rem">
      Category: {{ categoryData[categoryId] }}
      <EditButton :isEditing="false" @click="editCategory()" />
    </h5>

    <div v-if="scale" style="display: flex; align-items: center; width: 100%">
      <div class="surveycontainer" style="flex-grow: 1">
        <div class="optionContainer">
          <div
            :class="{
              selected: this.selected === index,
              deselected: this.selected !== index,
              option: true,
            }"
            v-for="(option, index) in scale.options"
            :key="index"
          >
            <h2>{{ option.label }}</h2>
          </div>
        </div>
        <div class="labelContainer">
          <h4 class="llabel">{{ scale.ltext }}</h4>
          <h4 class="clabel">{{ scale.ctext }}</h4>
          <h4 class="rlabel">{{ scale.rtext }}</h4>
        </div>
        <div
          class="labelpadding"
          v-if="scale.ltext !== '' || scale.ctext !== '' || scale.rtext !== ''"
        ></div>
      </div>
      <EditButton :isEditing="false" @click="editScale()" />
    </div>
    <div v-else>
      <h3
        class="editabletext"
        style="margin-top: 0.4rem; margin-bottom: 0.5rem"
      >
        Select scale
        <EditButton :isEditing="false" @click="editScale()" />
      </h3>
    </div>
    <button
      style="margin: 0; margin-top: 1rem; background-color: #dc3545"
      @click="deleteQuestion()"
    >
      <h3 style="margin: 0.3rem 0.5rem; color: #ffffff">Delete question</h3>
    </button>
  </div>
  <div class="selectScale" v-if="selectingScale">
    <div class="scaleSelection">
      <h1
        style="
          margin-left: 4rem;
          margin-right: 4rem;
          margin-bottom: 0;
          display: flex;
          align-items: center;
        "
      >
        Select scale
        <button
          @click="this.selectingScale = false"
          style="
            background-color: #dc3545;
            margin-bottom: 1rem;
            margin-left: 1rem;
          "
        >
          <h2>Cancel</h2>
        </button>
      </h1>

      <div v-for="scale in scales" v-bind:key="scale.id" class="scaleOption">
        <h2>{{ scale.name }}</h2>

        <div class="surveycontainer">
          <div class="optionContainer">
            <div
              class="option"
              v-for="(option, index) in scale.options"
              :key="index"
            >
              <h3>{{ option.label }}</h3>
            </div>
          </div>
          <div class="labelContainer">
            <h4 class="llabel">{{ scale.ltext }}</h4>
            <h4 class="clabel">{{ scale.ctext }}</h4>
            <h4 class="rlabel">{{ scale.rtext }}</h4>
          </div>
          <div
            class="optionSpacing"
            v-if="
              scale.ltext !== '' && scale.ctext !== '' && scale.rtext !== ''
            "
          />
          <button @click="selectScale(scale.id)">
            <h2>Select</h2>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="selectScale" v-if="selectingCategory">
    <div class="scaleSelection">
      <h1
        style="
          margin-left: 4rem;
          margin-right: 4rem;
          margin-bottom: 0;
          display: flex;
          align-items: center;
        "
      >
        Select category
        <button
          @click="selectingCategory = false"
          style="
            background-color: #dc3545;
            margin-bottom: 1rem;
            margin-left: 1rem;
          "
        >
          <h2>Cancel</h2>
        </button>
      </h1>

      <div
        v-for="(categoryName, id) in categoryData"
        v-bind:key="id"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: #ffffff44;
          border-radius: 1rem;
          padding: 0 1rem;
          margin-top: 1rem;
        "
      >
        <h2 style="margin: 0">{{ categoryName }}</h2>

        <button @click="selectCategory(id)">
          <h2>Select</h2>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import pointsStore from "../pointsStore.js";
import EditButton from "./EditButton.vue";
import axios from "axios";
import { baseurl } from "../api.js";
import accountStore from "../accountStore.js";

export default defineComponent({
  components: {
    EditButton: EditButton,
  },
  methods: {
    editCategory() {
      this.selectingCategory = true;
    },
    select(id) {
      if (this.selected !== id) {
        this.selected = id;
        //pointsStore.setResponse(this.$props.id, this.$props.options[id].points);
        return;
      }
      if (this.selected === id && this.deselectable) {
        this.selected = -1;
        pointsStore.delResponse(this.$props.id);
      }
    },
    selectScale(id) {
      axios
        .post(baseurl + "editquestionscale", {
          id: this.id,
          scaleid: id,
          p: accountStore.passcode,
        })
        .then((r) => {
          if (r.data.success) {
            this.selectingScale = false;
            this.$parent.fetchSurvey();
          }
        });
    },
    selectCategory(id) {
      axios
        .post(baseurl + "editquestioncategory", {
          questionId: this.id,
          categoryId: id,
          p: accountStore.passcode,
        })
        .then((r) => {
          if (r.data.success) {
            this.selectingCategory = false;
            this.$parent.fetchSurvey();
          }
        });
    },
    editText() {
      if (this.editingText) {
        axios
          .post(baseurl + "editquestiontext", {
            id: this.id,
            text: document.getElementById("textinput" + this.id).value,
            p: accountStore.passcode,
          })
          .then((r) => {
            if (r.data.success) {
              this.$parent.fetchSurvey();
            }
          });
      }
      this.editingText = !this.editingText;
    },
    editRequired() {
      axios
        .post(baseurl + "editrequired", {
          id: this.id,
          p: accountStore.passcode,
        })
        .then((r) => {
          if (r.data.success) {
            this.$parent.fetchSurvey();
          }
        });
    },
    editScale() {
      this.selectingScale = true;
    },
    deleteQuestion() {
      axios
        .post(baseurl + "deletequestion", {
          id: this.id,
          p: accountStore.passcode,
        })
        .then((r) => {
          if (r.data.success) {
            this.$parent.fetchSurvey();
          }
        });
    },
  },
  created() {
    axios
      .get(baseurl + "getscales", { params: { p: accountStore.passcode } })
      .then((r) => {
        this.scales = r.data;
      });
  },
  data() {
    return {
      selected: -1,
      editingText: false,
      selectingScale: false,
      scales: {},
      selectingCategory: false,
    };
  },
  name: "Question",
  props: {
    isfirst: Boolean,
    id: Number,
    text: String,
    scale: Object,
    deselectable: { type: Boolean, default: false },
    categoryData: Object,
    categoryId: Number,
  },
});
</script>

<style scoped>
.scaleOption {
  border: 1px solid #ffffff;
  border-radius: 1rem;
  margin-bottom: 1rem;
  padding: 0 1rem;
}

.selectScale {
  position: fixed;
  top: 0;
  left: 0;
  background-color: #000000cc;
  backdrop-filter: blur(8px);
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.scaleSelection {
  background-color: #00000055;
  padding: 1rem 3rem;
  border-radius: 1rem;
}

.scaleSelection h2 {
  margin-top: 0.5rem;
}

input,
textarea {
  border: 1px solid #555555;
  border-radius: 1rem;
  padding: 0.5rem 0.5rem;
  font-size: 1rem;
  font-weight: bold;
  height: 100%;
}

textarea {
  width: 100%;
}

.editabletext {
  display: flex;
  align-items: center;
}

.container {
  display: flex;
  align-items: flex-start;
  padding-left: 2rem;
  padding-right: 2rem;
  flex-direction: column;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.firstContainer {
  display: flex;
  align-items: flex-start;
  padding-left: 2rem;
  padding-right: 2rem;
  flex-direction: column;
  margin-top: 0;
  margin-bottom: 2rem;
}

.surveycontainer {
  width: 100%;
}

.optionContainer {
  display: flex;
  width: 100%;
}

.option {
  flex-basis: 100%;
  display: flex;
  flex-direction: column;
  margin: 0.2rem;
  padding: 0.1rem 0.2rem 0.1rem 0.2rem;
  border-radius: 1rem;
  transition: 0.25s;
  cursor: pointer;
}

.selected {
  background-color: #007bff;
  color: #ffff;
}

.deselected {
  background-color: #dddddd;
  color: #000010;
}

.option > h2 {
  margin: 1rem;
}

.labelContainer {
  position: relative;
  width: 100%;
}

.llabel,
.clabel,
.rlabel {
  position: absolute;
  margin-top: 0.4rem;
}

.llabel {
  left: 0.5rem;
}

.clabel {
  left: 50%;
  transform: translate(-50%, 0);
}

.rlabel {
  right: 0.5rem;
}

.labelpadding {
  height: 1rem;
}

.dotransition {
  transition: 300ms;
}

.requiredhighlight {
  color: rgb(216, 18, 18);
}

.requiredtexthighlight {
  color: rgb(247, 75, 75);
}

.qtitle {
  margin-bottom: 0.7rem;
  text-align: left;
  width: 100%;
}

.requiredqtitle {
  margin-bottom: 0.3rem;
}

.requiredtext {
  margin: 0 0 0.3rem 0.2rem;
}

.surveycontainer {
  width: 100%;
}

.optionContainer {
  display: flex;
  width: 100%;
  margin-top: 0.5rem;
  margin-bottom: 0;
}

.optionSpacing {
  margin-bottom: 1.5rem;
}

.option {
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0.2rem;
  padding: 0;
  border-radius: 1rem;
  transition: 0.25s;
  cursor: not-allowed;
  background-color: #dddddd;
  color: #000010;
}

.option > h3 {
  margin: 0.8rem;
}

.labelContainer {
  position: relative;
  width: 100%;
}

.llabel,
.clabel,
.rlabel {
  position: absolute;
  margin-top: 0.4rem;
}

.llabel {
  left: 0.5rem;
}

.clabel {
  left: 50%;
  transform: translate(-50%, 0);
}

.rlabel {
  right: 0.5rem;
}

button {
  background-color: #007bff;
  border: none;
  border-radius: 1rem;
  cursor: pointer;
  margin: 1rem 0;
}

button > h2 {
  color: #ffffff;
  margin: 0.7rem 1rem 0.7rem 1rem;
}
</style>